import { CrudStoreItemPartner360 } from '../../../../../classes/models/partner360/CrudStoreItemPartner360'

/**
 * @deprecated
 * This map probably will be replaced by crud like it's done with programType.
 * But it's definitely will be removed. Don't use it.
 * */
export const fyearHistoryMap = new Map<string, string>()
export const crudInfo: { id: string; key?: string | undefined }[] = [
  { id: CrudStoreItemPartner360.PartnerBasicInfo },
  { id: CrudStoreItemPartner360.ActionsPlan, key: 'MIFReplacement' },
  { id: CrudStoreItemPartner360.ActionsPlan, key: 'ActionsPlan' },
  { id: CrudStoreItemPartner360.CompensationScheme },
  { id: CrudStoreItemPartner360.JBPKeyInitiatives },
  { id: CrudStoreItemPartner360.Commitment, key: 'CheckPartnerSign' },
  { id: CrudStoreItemPartner360.JBPThingsToImprove, key: 'jbpThingsToImprove' },
  { id: CrudStoreItemPartner360.ActionsPlan, key: 'ThingsToImprove' },
  { id: CrudStoreItemPartner360.JBPDaasSummary, key: 'DaaSSummary' },
  { id: CrudStoreItemPartner360.ThirdPartySolutions, key: '3rdPartySolutions' },
  { id: CrudStoreItemPartner360.PartnerTargets, key: 'targets' },
  { id: CrudStoreItemPartner360.PartnerTargets, key: 'projections' },
  {
    id: CrudStoreItemPartner360.JBPTopTargetAccounts,
    key: 'topTargetAccounts',
  },
  {
    id: CrudStoreItemPartner360.JBPProgramsManagementPartner,
    key: 'JBPProgramsManagementPartner',
  },
  { id: CrudStoreItemPartner360.ActionsPlanMDF, key: 'ActionsPlanMDF' },
  {
    id: CrudStoreItemPartner360.ActionsPlanMDF,
    key: 'ActionsPlanMDFAllocations',
  },
  {
    id: CrudStoreItemPartner360.ActionsPlanMDF,
    key: 'DistributorsPlan',
  },
  { id: CrudStoreItemPartner360.JBPSummaryAndAchivements, key: 'achievements' },
  { id: CrudStoreItemPartner360.JBPActionCapabilities },
  { id: CrudStoreItemPartner360.JBPActionCapabilities, key: 'Dropdown' },
]
